import React, { useState } from 'react';
import { Grid, Typography } from '@material-ui/core';
import CustomAutocompleteSimple from 'components/CustomAutocompleteSimple';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from 'store';
import { RemoveFormContentProps } from '../interfaces';
import { IOptionData } from 'interfaces/utils';
import { useStyles } from './styles';
import RemoveButton from '../RemoveButton';
import { openAlert } from 'modules/alertHandler';
import { removeEPSAction } from 'modules/distributionContracts';

const RemoveEPS = ({ handleClose }: RemoveFormContentProps): JSX.Element => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [selectedEPSId, setSelectedEPSId] = useState<string | null>(null);
  const [selectedEPSName, setSelectedEPSName] = useState<string | null>(null);

  const { list: eps } = useSelector((state: RootState) => state.epsList);

  const distributionEPSOptions = eps.map((item) => {
    return { value: item.id, label: item.fantasyName };
  });

  const handleChangeEps = (newOption: IOptionData) => {
    setSelectedEPSId(newOption?.value || null);
    setSelectedEPSName(newOption?.label || null);
  };

  const handleClickAtRemove = () => {
    handleClose();
    dispatch(
      openAlert({
        title: 'Remover EPS?',
        content: `Tem certeza que deseja remover a EPS "${selectedEPSName}"?`,
        primaryButton: 'Sim',
        primaryButtonAction: removeEPSAction({
          epsId: selectedEPSId,
        }),
        secondaryButton: 'Não',
      }),
    );
  };

  return (
    <Grid container item direction="column" spacing={2}>
      <Grid item>
        <Typography>Selecione a EPS</Typography>
        <CustomAutocompleteSimple
          autocompleteProps={{
            className: classes.autoComplete,
            disableClearable: false,
          }}
          onChange={handleChangeEps}
          list={distributionEPSOptions}
        />
      </Grid>

      <Grid container item justifyContent="center">
        <RemoveButton disabled={!selectedEPSId} onClick={handleClickAtRemove} />
      </Grid>
    </Grid>
  );
};

export default RemoveEPS;
